__turbopack_context__.v({
  "card": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__card",
  "favoriteButton": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__favoriteButton",
  "image": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__image",
  "imageWrapper": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__imageWrapper",
  "info": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__info",
  "singleArticleCardMobileHorizontal": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__singleArticleCardMobileHorizontal",
  "title": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__title",
  "titleWrapper": "SingleArticleCardMobileHorizontal-module-scss-module__n7RDbG__titleWrapper",
});
